module.exports = __webpack_public_path__ + "4b902e895d825dfa22f00b1f2f79ded4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/22-08-06DaddaDice2-mini.jpg
// module id = 825
// module chunks = 0